import { Navigate, useRoutes } from 'react-router-dom';
// config
import { useEffect } from 'react';
import { PATH_AFTER_LOGIN } from 'src/config-global';
//
import { useCheckPermissionMutation } from 'src/store/data/data-api';
import { useAuthContext } from 'src/auth/hooks';
import { mainRoutes } from './main';

import { dashboardRoutes } from './dashboard';

// ----------------------------------------------------------------------

export default function Router() {
  const { user, updateUserPermission, authenticated } = useAuthContext();

  const [checkPermission] = useCheckPermissionMutation();


  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const response = await checkPermission().unwrap();
        if (response) {
          updateUserPermission(response.permissions);
        }
      } catch (error) {
        console.error('Failed to fetch permissions:', error);
      }
    };

    if (authenticated) {
      fetchPermissions();
    }

  }, [authenticated, checkPermission, updateUserPermission]);

  return useRoutes([
    {
      path: '/',
      element: <Navigate to={PATH_AFTER_LOGIN} replace />,
    },

    ...(user ? dashboardRoutes(user) : []),

    // Main routes
    ...mainRoutes,

    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
